import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fin-mana",
  "use": "icon-fin-mana-usage",
  "viewBox": "0 0 24 21.33333396911621",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 24 21.33333396911621\" id=\"icon-fin-mana\"><g><path d=\"M2.66667,3.33333C2.66667,2.96514,2.96514,2.66667,3.33333,2.66667L17.3333,2.66667C18.0697,2.66667,18.6667,2.06971,18.6667,1.33333C18.6667,0.596954,18.0697,0,17.3333,0L3.33333,0C1.49238,0,0,1.49238,0,3.33333L0,18.6667C0,20.1394,1.19391,21.3333,2.66667,21.3333L21.3333,21.3333C22.8061,21.3333,24,20.1394,24,18.6667L24,6.66667C24,5.19391,22.8061,4,21.3333,4L3.33333,4C2.96514,4,2.66667,3.70152,2.66667,3.33333ZM16.6667,14.6667C17.7712,14.6667,18.6667,13.7712,18.6667,12.6667C18.6667,11.5621,17.7712,10.6667,16.6667,10.6667C15.5621,10.6667,14.6667,11.5621,14.6667,12.6667C14.6667,13.7712,15.5621,14.6667,16.6667,14.6667Z\" fill-rule=\"evenodd\" fill=\"#6C5FFC\" fill-opacity=\"1\" style=\"mix-blend-mode:passthrough\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fin-mana.svg
// module id = dl47
// module chunks = 119